import axios from 'axios';
import { Component, Provide, Vue } from 'vue-property-decorator';
import { EventBus } from '.././event-bus';
import { rejects } from 'assert';
import Swal from 'sweetalert2';

Component.registerHooks(['beforeRouteLeave']);

@Component({})
export default class BaseFormEdit extends Vue {
  //@ts-ignore
  @Provide() parentValidator = this.$validator;
  public isDataLoaded = false;
  public removeFormValidation = false;
  public urlPrefix = '';
  public path = '';

  protected form = {} as any;
  protected initialFormValues = {} as any;
  protected isStatusChangeError = false;

  public confirm(message: any, action: any) {
    // @ts-ignore
    this.$swal({
      icon: 'warning',
      title: this.$t('Предупреждение'),
      content: message,
      buttons: [this.$t('Нет'), this.$t('Да')],
    }).then(async (doChange: any) => {
      if (doChange) {
        action.call();
      }
    });
  }

  protected created() {
    this.fetchData();
  }

  isTwoDateEqual(a: Date, b: Date) {
    if(!(a instanceof Date)) return false;
    if(!(b instanceof Date)) return false;
    a.setHours(0, 0, 0, 0);
    b.setHours(0, 0, 0, 0);

    return a == b;
  }

  deepFormValuesEqual(a: any, b: any) {
    if(a instanceof Date || b instanceof Date)
    {
      return this.isTwoDateEqual(a, b);
    }

    if (a === b || (a === '' && b === null) || (a === undefined && b === null) || b === undefined)
      return true;

    if (typeof a != 'object' || typeof b != 'object') {
      return false;
    }    

    a = a === null ? {} : a;
    b = b === null ? {} : b;

    let keysA = Object.keys(a),
      keysB = Object.keys(b);

    if (keysA.length != keysB.length && !a.hlaTypeName && !a.fileTypeId) {
      return false;
    } 

    for (let key of keysA) {
      if(key == 'ctFileInfo'){
        return true;
      }
      
      if (!this.deepFormValuesEqual(a[key], b[key]) && !a.fileTypeId) {
        return false;
      }        
    }

    return true;
  }

  protected onFetchDataError() {

  }

  protected onFetchDataFinish() {

  }

  protected beforeFetchData() {

  }

  private fetchData() {
    this.beforeFetchData();
    this.isDataLoaded = false;
    EventBus.$emit('showThrobber');
    let url = this.$route.path;
    if (this.urlPrefix) {
      if (this.path) {
        url = this.path;
      }
      url = '/' + this.urlPrefix + url;
    }
    axios
      .get(url)
      .then((response) => {
        this.form = Object.assign({}, response.data);
        this.initialFormValues = JSON.parse(JSON.stringify(response.data));
        for (let prop in this.form) {
          if (this.form[prop] === null) {
            this.form[prop] = '';
          }
        }
        EventBus.$emit('hideThrobber');
        this.isDataLoaded = true;
        this.onFetchDataFinish();
        //@ts-ignore
        this.$validator.reset();
      })
      .catch(()=> this.onFetchDataError())
      .finally(() => {
        EventBus.$emit('hideThrobber');
      });
  }

  get title() {
    return this.isNew ? String(this.$t('Добавление')) : String(this.$t('Редактирование'));
  }

  get isNew(): Boolean {
    return !(this.form.id && this.form.id.length > 0);
  }

  async submit(
    path: any,
    isGoBack = false,
    routeBackName: any = '',
    formData: FormData | null = null,
    submitErrorCallback: any = null,
    isGroupG: any = null
  ) {
    this.isStatusChangeError = false;
    //@ts-ignore
    if (this.removeFormValidation || await this.$validator.validateAll()) {
      EventBus.$emit('showThrobber');
      let form = this.form;
      if(this.urlPrefix) {
        path = '/' + this.urlPrefix + path;
        form = { entity: form };
      }
      return await axios
        .post(
          path,
          formData || form,
          formData != null
            ? { headers: { 'Content-Type': 'multipart/form-data' } }
            : {}
        )
        .then((response) => {
          const labels = document.querySelectorAll("label");
          for (const label of labels) {
            label.classList.remove('is-highlighted');            
          }
          this.initialFormValues = Object.assign({}, this.form);
          EventBus.$emit('success', { msg: this.$t('Запись успешно сохранена!') });
          if (routeBackName) {
            this.$router.push({ name: routeBackName });
          } else if (isGoBack) {
            this.goBack();
          }  else if (isGroupG) {
            this.$router.replace(`${path}/${response.data.id}`);
            this.fetchData();
          }  else if (!this.$route.path.endsWith('add') && !this.$route.path.endsWith('relative')) {
            this.fetchData();
          } else if (this.$route.path.endsWith('add') || this.$route.path.endsWith('relative')) {
            let identifier = response.data.id || response.data;
            this.$router.replace(
              this.$route.path.replace('/relative', '').replace('/add', '/' + identifier)
            );
            this.fetchData();
          }
          EventBus.$emit('hideThrobber');

          return (response && response.data && response.data.id) ? response.data.id : null;
        })
        .catch((error) => {
          EventBus.$emit('hideThrobber');
          if (submitErrorCallback) {
            submitErrorCallback(error);
            this.isStatusChangeError = true;
          } else {
            if(error.data.notificationType == 0) {
              if(error.data.callback) {
                this[error.data.callback](error.data);  
              } else {
                //@ts-ignore
                this.$swal(this.$t('Ошибка'), error.data.message, 'error');
              }
            } else {
              var message = error.status == 401 ? this.$t('Время сессии истекло') : error.data.message;
              EventBus.$emit('error', { msg: message });
            }
          }
        });
    } else {
      this.isStatusChangeError = true;
    }
  }

  isFormChanged() {
    return !this.deepFormValuesEqual(this.form, this.initialFormValues);
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    next();
  }

  goBack() {
    window.history.length > 2 ? this.$router.go(-1) : this.$router.push('/');
  }

  goOnHomePage() {
    this.$router.push('/');
  }

  calculateAge(dob: Date) {
    if (dob) {
      const diffMs = Date.now() - dob.getTime();
      const ageDt = new Date(diffMs);

      return Math.abs(ageDt.getUTCFullYear() - 1970);
    }

    return null;
  }

  transformName(value: string, name: string) {
    const names = value.split(' ');

    names.map((item, index) => {
      let nameParts: string[] = [];

      if (item) {
        nameParts = item.split('-');

        nameParts.map((name, i) => {
          if (name) {
            nameParts[i] =
              name.substring(0, 1).toUpperCase() +
              name.substring(1).toLowerCase();
          }
        });
      }

      names[index] = nameParts.join('-');
    });

    this.form[name] = names.join(' ');
  }

  calculateMonth(dob: Date) {
    if (dob) {
      const diffMs = Date.now() - dob.getTime();
      const ageDt = new Date(diffMs);

      return ageDt.getMonth();
    }

    return null;
  }

  get timeoutDisabled() {
    if(this.form && this.form.timeoutUserGroups && this.$auth.user())
    {
      var userGroup = this.form.timeoutUserGroups.find((t: any) => t == this.$auth.user().impersonateGroup);
    
      return !userGroup;
    }
    
    return true;
  }

  highlightAllLabels(errors: any) {
    let errorFields = errors.match(/<strong>(.*?)<\/strong>/g);
    if(errorFields && errorFields.length > 0)
    {
      let result = errorFields.map(function(val: any){
        return val.replace(/<\/?strong>/g,'');
      });

      const labels = document.querySelectorAll("label");
      for (const label of labels) {
        let labelText = label.innerText;
        if (labelText && result.includes(labelText.trim())) {
          label.classList.add('is-highlighted');
        }
      }  
    }    
  }

  showStatusChangeError(e: any) {
    if(e.data.callback) {
      this[e.data.callback](e.data); 
    } else {
      this.highlightAllLabels(e.data.message);    
      Swal(this.$t('Ошибка') as string, e.data.message, 'warning');
    }
  } 

}
